import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Text } from '@ps-design-system/components/Text';
import { Button } from '@ps-design-system/components/Button';
import CheckCircleIcon from '@ps-design-system/icons/CheckCircle/CheckCircle24';
import PlusIcon from '@ps-design-system/icons/Plus/Plus20';

import { useUploadModal } from '../context/UploadModalContext';
import { useUploaderPageData } from '../context/UploaderPageContext';

const UploaderEmptyState = () => {
  const { openMediaModal } = useUploadModal();
  const { isMobile } = useUploaderPageData();
  const typography = isMobile ? 'headline-2-b' : 'headline-3-b';

  return (
    <div className='uploader-empty-content'>
      <div className='outter-container'>
        <div className='inner-container tw-bg-gray-100'>
          <div className='header'>
            <Text typeface={typography}>
              <FormattedMessage id="uploader.tips.empty_header" defaultMessage="Tips to make your gallery stand out"/>
            </Text>
          </div>
          <div className='body'>
            <div className='uploader-row'>
              <div className='icon tw-text-purple-800'><CheckCircleIcon /></div>
              <div className='uploader-column'>
                <div>
                  <Text typeface="body-2-m">
                    <FormattedMessage id="uploader.tips.high_quality" defaultMessage="High quality, wide shots"/>
                  </Text>
                </div>
                <div>
                  <Text typeface="body-2-long">
                    <FormattedMessage id="uploader.tips.high_quality_description" defaultMessage="Use horizontal photos that are at least 1,000 pixels wide."/>
                  </Text>
                </div>
              </div>
            </div>
            <div className='uploader-row'>
              <div className='icon tw-text-purple-800'><CheckCircleIcon /></div>
              <div className='uploader-column'>
                <div>
                  <Text typeface="body-2-m">
                    <FormattedMessage id="uploader.tips.showcase" defaultMessage="Showcase your whole space"/>
                  </Text>
                </div>
                <div>
                  <Text typeface="body-2-long">
                    <FormattedMessage id="uploader.tips.showcase_description" defaultMessage="Peerspace requires a minimum of 5 photos but we recommend adding 10 or more to give a better idea of the layout and rooms."/>
                  </Text>
                </div>
              </div>
            </div>
            <div className='uploader-row'>
              <div className='icon tw-text-purple-800'><CheckCircleIcon /></div>
              <div className='uploader-column'>
                <div>
                  <Text typeface="body-2-m">
                    <FormattedMessage id="uploader.tips.natural_light" defaultMessage="Use natural color and light"/>
                  </Text>
                </div>
                <div>
                  <Text typeface="body-2-long">
                    <FormattedMessage id="uploader.tips.natural_light_description" defaultMessage="No black & white or heavy filters. Because bright, well-lit space feel more welcoming, we recommend taking photos in natural daylight."/>
                  </Text>
                </div>
              </div>
            </div>
            <div className='uploader-row'>
              <div className='icon tw-text-purple-800'><CheckCircleIcon /></div>
              <div className='uploader-column'>
                <div>
                  <Text typeface="body-2-m">
                    <FormattedMessage id="uploader.tips.simple" defaultMessage="Keep it simple"/>
                  </Text>
                </div>
                <div>
                  <Text typeface="body-2-long">
                    <FormattedMessage id="uploader.tips.simple_description" defaultMessage="No watermarks, collages, or screenshots."/>
                  </Text>
                </div>
              </div>
            </div>
            {
              !isMobile && (
                <div className='upload-button'>
                  <Button appearance="black" prefix={<PlusIcon />} onClick={openMediaModal} attributes={{ 'data-testing-id': 'upload-button-tips' }}>
                    <FormattedMessage id="uploader.page.upload" defaultMessage="Upload"/>
                  </Button>
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploaderEmptyState;
